import React from 'react';
import '../styles/Footer.css';

const PHONES = [
    { label: '+52 55 7653 6610', href: 'tel:+525576536610' },
    { label: '+52 55 5093 5159', href: 'tel:+525550935159' },
];

const LEGAL_LINKS = [
    { label: 'Aviso de privacidad', href: '/aviso-de-privacidad.html' },
    { label: 'Términos y condiciones de uso', href: '/terminos-y-condiciones.html' },
];

export default function Footer() {
    return (
        <footer className="App-Footer">
            <p className="App-Footer__brand">
                MiReclu es una marca de <strong>MARKGAN, S.A. de C.V.</strong>
            </p>

            <address className="App-Footer__address">
                Domicilio: Boulevard (Blvd.) Manuel Ávila Camacho 5, Piso 10 Torre B, Col. Lomas de Sotelo, Naucalpan de Juárez, Estado de México, México, C.P. 53390
            </address>

            <ul className="App-Footer__list" aria-label="Teléfonos de contacto">
                {PHONES.map(({ label, href }) => (
                    <li key={href}>
                        <a className="App-Footer__phone" href={href}>
                            {label}
                        </a>
                    </li>
                ))}
            </ul>

            <nav aria-label="Documentos legales">
                <ul className="App-Footer__list">
                    {LEGAL_LINKS.map(({ label, href }) => (
                        <li key={href}>
                            <a
                                className="App-Footer__link"
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {label}
                                <span className="App-Footer__sr"> (se abre en una pestaña nueva)</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </footer>
    );
}
